import { useCallback, useEffect, useState } from "react";
import { notify } from "../../../assets/helpers/toast";
import { Header } from "../../common/Header/Header";
import { ActionButton } from "../../common/Buttons/Buttons";
import { FilterDatePicker } from "../../common/Forms/Input/Input";
import { ComplaintsTable } from "../../common/Tables/Tables";
import { complaintsTableHeader } from "../../../assets/helpers/tables";
import { LoadSpinner } from "../../common/LoadSpinner/LoadSpinner";
import { ComplaintsService } from "../../../services/complaintsService";
import moment from "moment";
import * as schemas from "../../../assets/schemas/schemas";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, useWatch } from "react-hook-form";
import {
  CreateComplaintModal,
  EditComplaintModal,
} from "../../common/Modals/Modals";
import {
  customerSatisfactionOptions,
  solutionProvidedOptions,
  complaintStatusOptions,
  complaintTypesEnumOptions,
  serviceComplainOptions,
  socialNetworkOptions,
  LeadContributorOptions,
  SegmentationOptions,
  LeadContributorEnum
} from "../../../assets/helpers/options";
import { servicesService } from "../../../services/servicesService";
import { usersService } from "../../../services/usersService";

const colaborators = [
  {
    key: LeadContributorEnum.OPERATOR,
    value: 'OPERATIONS_OPERATOR',
  },
  {
    key: LeadContributorEnum.TRAFFIC_ASSISTANT,
    value: 'OPERATIONS_FLOTA_AV',
  },
  {
    key: LeadContributorEnum.RUDE,
    value: 'OPERATIONS_FLOTA_GRUA',
  }
]

export const Complaints = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(schemas.createComplaintSchema()),
  });

  const leadContributorWatch = useWatch({
    control,
    name: "leadContributor",
    defaultValue: "",
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    reset: reset2,
    control: control2,
    watch: watch2,
    setValue: setValue2,
  } = useForm({
    resolver: yupResolver(schemas.editComplaintSchema()),
  });

    const leadContributorWatchUpdate = useWatch({
    control: control2,
    name: "leadContributor",
    defaultValue: "",
  });

  const [sinceDate, setSinceDate] = useState(new Date());
  const [untilDate, setUntilDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [complaintsData, setComplaintsData] = useState({
    limit: 50,
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    description: "",
  });
  const [leadContributorNameList, setLeadContributorNameList] = useState([]);

  const handleShowCreateModal = () => {
    setShowCreateModal(true);
  };

  const handleCloseCreateModal = () => {
    reset();
    setValue("category", "");
    setValue("complaintDate", "");
    setValue("clientName", "");
    setValue("clientPhone", "");
    setValue("plate", "");
    setValue("socialMedia", "");
    setValue("classification", "");
    setValue("details", "");
    setValue("status", "");
    setValue("solution", "");
    setValue("solutionAmount", "");
    setValue("clientSatisfaction", "");
    setValue("solutionDetails", "");
    setValue("leadContributor", "");
    setValue("contributorName", "");
    setValue("segmentation", "");
    setShowCreateModal([]);
    setShowCreateModal(false);
  };

  const handleSinceDateChange = (e) => {
    if (e > untilDate) {
      notify("Ingrese una fecha en un rago valido ", "info");
    } else {
      setSinceDate(e);
    }
  };

  const handleUntilDateChange = (e) => {
    if (e < sinceDate) {
      notify("Ingrese una fecha en un rago valido ", "info");
    } else {
      setUntilDate(e);
    }
  };

  const handlePageChange = (event, value) => {
    setComplaintsData((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * complaintsData?.limit,
      };
    });
  };

  const getServicesByCode = async (code) => {
    try {
      const response = await servicesService.getServicesByCode(code);
      if (response.status === 200) {
        return response?.data;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  };
  const updateStatus = async (id, status, data) => {
    let body = {
      status,
      solution: data?.solution,
      solutionAmount: data?.solutionAmount,
      solutionDetails: data?.solutionDetails,
      clientSatisfaction: data?.clientSatisfaction,
    };
    setIsLoading(true);
    ComplaintsService.editComplaint(id, body)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Reporte de queja creado correctamente`, "success");
          reset();
          handleCloseCreateModal();
          getComplaints();
          setIsLoading(false);
        } else {
          notify(`${response.message}`, "error");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const createComplaint = handleSubmit(async (data) => {

    if (!data?.plate && !data?.serviceId && !data?.socialMedia) {
      notify(
        "Debe incluir codigo de servicio, placa o red social",
        "error"
      );
      return null;
    }

    const deleteIfNoValue = (attr) => {
      if (!data?.[attr]) {
        delete data[attr];
      }
    };

    deleteIfNoValue("serviceId");
    deleteIfNoValue("category");
    deleteIfNoValue("plate");
    deleteIfNoValue("solution");
    deleteIfNoValue("clientSatisfaction");
    deleteIfNoValue("solutionDetails");
    deleteIfNoValue("socialMedia");
    deleteIfNoValue("solutionAmount");


    const body = {
      serviceId: data?.serviceId,
      complaintDate: moment(data?.complaintDate).format("YYYY-MM-DD"),
      clientName: data?.clientName,
      clientPhone: data?.clientPhone,
      details: data?.details,
      classification: data?.classification,
      serviceCode: data?.serviceCode,
      status: data?.status,
      solution: data?.solution,
      clientSatisfaction: data?.clientSatisfaction,
      solutionDetails: data?.solutionDetails,
      plate: data?.plate,
      socialMedia: data?.socialMedia,
      category: data?.category,
      ...(data?.leadContributor && { leadContributor: data?.leadContributor }),
      ...(data?.contributorName && { contributorName: data?.contributorName }),
      segmentation: data?.segmentation,
    };

    if (data?.solutionAmount) {
      body.solutionAmount = data?.solutionAmount;
    }

    setIsLoading(true);
    ComplaintsService.createComplaint(body)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Reporte de queja creado correctamente`, "success");
          reset();
          handleCloseCreateModal();
          getComplaints();
          setIsLoading(false);
        } else {
          notify(`${response.message}`, "error");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  });

  const handleChangeStatusForEdit = () => {
    // setValue2("solution", "");
    // setValue2("solutionAmount", 0);
    // setValue2("solutionDetails", "");
    // setValue2("clientSatisfaction", "");
  };

  const handleChangeStatusForCreate = () => {
    if (watch("status") === "Finalizado") {
      setValue("solutionAmount", 0);
    }
  };

  const editComplaint = handleSubmit2(async (data) => {
    let id = data.id;

    if (!data?.plate && !data?.serviceId && !data?.socialMedia) {
      notify(
        "Debe incluir codigo de servicio, placa o red social",
        "error"
      );
      return null;
    }

    const deleteIfNoValue = (attr) => {
      if (!data?.[attr]) {
        delete data[attr];
      }
    };

    deleteIfNoValue("category");
    deleteIfNoValue("plate");
    deleteIfNoValue("socialMedia");
    deleteIfNoValue("solutionAmount");



    delete data.serviceCode;
    delete data.id;
    delete data.serviceId;

    setIsLoading(true);
    ComplaintsService.editComplaint(id, data)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Reporte de queja Editado correctamente`, "success");
          reset2();
          setShowEditModal(false);
          getComplaints();
          setIsLoading(false);
        } else {
          notify(`${response.message}`, "error");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  });

  const getContributorNameIdByName = async ({ name, leadContributor }) => {
    if (leadContributor && name) {
      const params = {
      role: colaborators.find((colab) => colab.key === leadContributor)?.value,
      limit: 300,
      offset: 0,
      module: "",
    };
      usersService
        .getUsers(params)
        .then((response) => {
            if (response.status === 200 && Array.isArray(response?.data?.users)) {
            const data = response.data.users.map(user => ({
              name: `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim(),
              _id: user._id,
            }));
            const leadContributorNameFind = data.find(user => user.name === name);
            setLeadContributorNameList(data);
            setValue2("contributorName", leadContributorNameFind ? leadContributorNameFind._id : "");
            }
        })
        .catch((error) => {
          console.error("Error fetching users:", error);
          setLeadContributorNameList([]); // Clear the list on error
        });
    }
    
  }

  const handleShowEditModal = async (data) => {
    setValue2("id", data?._id);
    setValue2("serviceId", data?.serviceId);
    setValue2("category", data?.category);
    setValue2("socialMedia", data?.socialMedia);
    setValue2("plate", data?.plate);
    setValue2("complaintDate", new Date(data?.complaintDate));
    setValue2("clientName", data?.clientName);
    setValue2("clientPhone", data?.clientPhone);
    setValue2("details", data?.details);
    setValue2("classification", data?.classification);
    setValue2("serviceCode", data?.serviceCode);
    setValue2("status", data?.status);
    setValue2("solution", data?.solution);
    setValue2("clientSatisfaction", data?.clientSatisfaction);
    setValue2("solutionDetails", data?.solutionDetails);
    if (data?.solutionAmount) {
      setValue2("solutionAmount", data?.solutionAmount);
    }
    setValue2("leadContributor", data?.leadContributor);
    setValue2("segmentation", data?.segmentation);
    await getContributorNameIdByName({name: data?.contributorName, leadContributor: data?.leadContributor});

    setShowEditModal(true);
  };

  const getComplaints = (byMail) => {
    setIsLoading(true);

    const params = {
      dateFrom: moment(sinceDate).format("YYYY-MM-DD"),
      dateTo: moment(untilDate).format("YYYY-MM-DD"),
    };

    if (byMail) {
      params.byMail = true;
    }

    ComplaintsService.getComplaints(params)
      .then((response) => {
        if (response.status === 200) {
          if (byMail) {
            notify(`Recibirá un exportable a su correo electrónico`, "info");
            setIsLoading(false);
            return;
          } else {
            setComplaintsData((prevState) => {
              return {
                ...prevState,
                data: response?.data?.complaints,
                count: response?.data?.total,
              };
            });
            setIsLoading(false);
          }
          setIsLoading(false);
        } else {
          notify(`${response.message}` || "error", "error");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
    return true;
  };

    const getUsers = useCallback((leadContributorWatch) => {
      console.log("Fetching users for lead contributor || :", leadContributorWatch);
      console.log("Colaborators List: ===", colaborators);
      const params = {
        role: colaborators.find((colab) => colab.key === leadContributorWatch)?.value,
        limit: 300,
        offset: 0,
        module: "",
      };
      console.log("Params for fetching users: ===", params);
      usersService
        .getUsers(params)
        .then((response) => {
            if (response.status === 200 && Array.isArray(response?.data?.users)) {
            const data = response.data.users.map(user => ({
              name: `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim(),
              _id: user._id,
            }));
            setLeadContributorNameList(data);
            } else {
            notify(`${response.message}`, "error");
          }
        })
        .catch((error) => {
          console.error("Error fetching users:", error);
          setLeadContributorNameList([]); // Clear the list on error
        });
    }
      ,[]);

  useEffect(() => {
    getComplaints();
  }, [
    complaintsData?.page,
    complaintsData?.offset,
    complaintsData?.limit,
    sinceDate,
    untilDate,
  ]);

  useEffect(() => {
    if ((showEditModal || showCreateModal) && (leadContributorWatch || leadContributorWatchUpdate)) {
      console.log("Lead Contributor Watch Create:", leadContributorWatch);
      console.log("Lead Contributor Watch Update:", leadContributorWatchUpdate);
      getUsers(leadContributorWatch || leadContributorWatchUpdate);
    }
  }, [showCreateModal, leadContributorWatch, leadContributorWatchUpdate, getUsers, showEditModal])
  

  return (
    <>
      <Header />
      <LoadSpinner show={isLoading} />
      <CreateComplaintModal
        show={showCreateModal}
        handleClose={() => handleCloseCreateModal()}
        title={"Registrar Nueva Queja"}
        register={register}
        errors={errors}
        options={{
          classificationOptions: complaintTypesEnumOptions,
          solutionOptions: solutionProvidedOptions,
          clientSatisfactionOptions: customerSatisfactionOptions,
          statusOptions: complaintStatusOptions,
          serviceComplainOptions: serviceComplainOptions,
          socialNetworkOptions: socialNetworkOptions,
          LeadContributorOptions: LeadContributorOptions,
          SegmentationOptions: SegmentationOptions,
          leadContributorNameList: leadContributorNameList
        }}
        action={createComplaint}
        control={control}
        watch={watch}
        setValue={setValue}
        getServicesByCode={getServicesByCode}
        onChange={{
          handleChangeStatus: handleChangeStatusForCreate,
        }}
      />
      <EditComplaintModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        title={"Editar Queja"}
        register={register2}
        errors={errors2}
        options={{
          classificationOptions: complaintTypesEnumOptions,
          solutionOptions: solutionProvidedOptions,
          clientSatisfactionOptions: customerSatisfactionOptions,
          statusOptions: complaintStatusOptions,
          serviceComplainOptions: serviceComplainOptions,
          socialNetworkOptions: socialNetworkOptions,
          LeadContributorOptions: LeadContributorOptions,
          SegmentationOptions: SegmentationOptions,
          leadContributorNameList: leadContributorNameList
        }}
        action={editComplaint}
        control={control2}
        watch={watch2}
        setValue={setValue2}
        getServicesByCode={getServicesByCode}
        onChange={{
          handleChangeStatus: handleChangeStatusForEdit,
        }}
      />
      <div className="service-with-container container">
        <div
          className=""
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h1 className="title-component">Sección de Quejas Operaciones</h1>
          <ActionButton action={() => getComplaints(true)} label={"Exportar"} />
        </div>
        <div
          className="breadcrumb-container"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: "1%",
          }}
        >
          <div
            className="providers-buttons-container"
            style={{
              width: "50%",
              justifyContent: "left",
              gap: "1%",
            }}
          >
            <FilterDatePicker
              bootstrap={"col-4"}
              label={"Desde"}
              type={"date"}
              name={"untilDate"}
              placeholder={""}
              onChange={handleSinceDateChange}
              value={sinceDate}
            />{" "}
            <FilterDatePicker
              bootstrap={"col-4"}
              label={"Hasta"}
              type={"date"}
              name={"untilDate"}
              placeholder={""}
              onChange={handleUntilDateChange}
              value={untilDate}
            />
          </div>
          <ActionButton
            action={() => handleShowCreateModal()}
            label={"Reportar nueva queja"}
          />
        </div>
        <div className="gray-line"></div>
        <div className="filter-button-container"></div>
        <br />
        <ComplaintsTable
          header={complaintsTableHeader}
          dataTable={complaintsData}
          handlePageChange={handlePageChange}
          edit={handleShowEditModal}
          updateStatus={updateStatus}
        />
      </div>
    </>
  );
};
